import { render, staticRenderFns } from "./ModalAsignarProductosATarimaComponent.vue?vue&type=template&id=5b8459d9&"
import script from "./ModalAsignarProductosATarimaComponent.vue?vue&type=script&lang=js&"
export * from "./ModalAsignarProductosATarimaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports